import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ConfigurationConstant } from "./ConfigurationConstant";

const initialState = {
  ConfigurationTableList: {},
  ConfigurationTable: {
    isLoading: false,
  },

  ConfigurationCancelList: [],
};

export const GlobleConfigurationReducer = persistReducer(
  {
    storage,
    key: "ConfigurationTable",
    whitelist: [" ConfigurationTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case ConfigurationConstant.CONFIGURATION_TABLE_REQUEST: {

        return {
          ...state,
          ConfigurationTableList: [],
          ConfigurationTable: {
            isLoading: true,
          },
        };
      }

      case ConfigurationConstant.CONFIGURATION_TABLE_RESPONSE: {

        return {
          ...state,
          ConfigurationTableList: payload,
          ConfigurationTable: {
            isLoading: false,
          },
        };
      }

      case ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_REQUEST: {
        return {
          ...state,
          ConfigurationCancelList: [],
          Configuration: {
            isLoading: true,
          },
        };
      }

      case ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_RESPONSE: {
        return {
          ...state,
          ConfigurationCancelList: payload,
          ConfigurationCancel: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
